import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'Center' })({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    justifySelf: 'center',
    alignSelf: 'center',
    flex: 1,
    height: '100%',
    textAlign: 'center',
  },
});

interface CenterProps {
  readonly children: React.ReactNode;
  readonly className?: string;
}

export const Center: React.FC<CenterProps> = ({ children, className = '' }) => {
  const { classes, cx } = useStyles();

  return (
    <div className={cx(classes.root, className)}>
      {children}
    </div>
  );
};
